import { useProject } from '../../project-hooks/useProject';
import { formatNumber } from '../../../utils';
import { useDispatch } from 'react-redux';
import { useProjectTimeline } from '../../project-timeline/useProjectTimeline';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import { openActivityModal } from '../../project-activities-actions';
import styles from './NumberOfRecentTransactions.module.less';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import { RECENTLY_SUPPORTED_TEXT_KEY } from '../../i18n/project-i18n-model';
import { Icon } from '@sb1/ffe-icons-react';
import trendingUp from '@sb1/ffe-icons/icons/open/500/sm/trending_up.svg';
import { SmallText, StrongText } from '@sb1/ffe-core-react';
import { useNumberOfRecentTransactions } from './useNumberOfRecentTransactions';

export const NumberOfRecentTransactions = () => {
    const dispatch = useDispatch();
    const project = useProject();
    const showHistory = useProjectTimeline(project);
    const { eligible, numberOfRecentTransactions } = useNumberOfRecentTransactions();

    const texts = useI18nTexts([RECENTLY_SUPPORTED_TEXT_KEY]);

    if (!eligible) {
        return null;
    }

    const showActivityModal = () => {
        trackEvent('number-of-recent-transactions', 'click', { channel: 'mobile' });
        if (showHistory) {
            dispatch(openActivityModal());
        }
    };

    return (
        <button
            className={`${styles.wrapper} ${styles.mobileWrapper}`}
            onClick={showActivityModal}
            data-recent-transactions={true}
        >
            <div className={styles.supportedNumber}>
                <Icon fileUrl={trendingUp} className={styles.supportIcon} />
                <StrongText className={styles.trendingText}>{formatNumber(numberOfRecentTransactions)}</StrongText>
            </div>
            <SmallText className={styles.supportedText}>{texts[RECENTLY_SUPPORTED_TEXT_KEY]}</SmallText>
        </button>
    );
};
